"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WBTTTokenFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "burner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Burn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Mint",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MintFinished",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
        ],
        name: "OwnershipRenounced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "Pause",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "Unpause",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "allocateTo",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "claimOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseApproval",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "finishMinting",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_addedValue",
                type: "uint256",
            },
        ],
        name: "increaseApproval",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "mintingFinished",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract ERC20Basic",
                name: "_token",
                type: "address",
            },
        ],
        name: "reclaimToken",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class WBTTTokenFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.WBTTTokenFactory = WBTTTokenFactory;
WBTTTokenFactory.bytecode = _bytecode;
WBTTTokenFactory.abi = _abi;
//# sourceMappingURL=WBTTTokenFactory.js.map